module.exports = __webpack_public_path__ + "img/ic_roman-list.bec28146.svg";